import { PersonRemoveOutlined } from '@mui/icons-material';
import { FormControlLabel, Radio, Stack, Typography } from '@mui/material';
import useTranslation from 'hooks/useTranslation/useTranslation';
import React from 'react';
import { DELETE_GROUP_MEMBER_ACTION } from './constants';
import DeleteGroupOption from './DeleteGroupOption';

interface DeleteGroupAndUsersOptionProps {
  isSelected: boolean;
  totalMembersCount: number;
}

const DeleteGroupAndUsersOption: React.FC<DeleteGroupAndUsersOptionProps> = ({ isSelected, totalMembersCount }) => {
  const { translation } = useTranslation();

  return (
    <DeleteGroupOption isSelected={isSelected}>
      <FormControlLabel
        id="delete-all-users-option"
        value={DELETE_GROUP_MEMBER_ACTION.delete}
        control={<Radio />}
        label={translation.delete_group_and_all_users}
      />
      <Stack flexDirection="row" sx={{ px: 1.25, gap: 2 }}>
        <Stack>
          <Stack flexDirection="row" gap={1}>
            <PersonRemoveOutlined color="error" />
            <Typography variant="body2" color="textPrimary">
              {`${totalMembersCount} ${translation.users}`}
            </Typography>
          </Stack>
          <Typography variant="caption" color="textSecondary">
            {translation.will_be_permanently_deleted_from_the_system_including_users.replace(
              '{{count}}',
              String(totalMembersCount)
            )}
          </Typography>
        </Stack>
      </Stack>
    </DeleteGroupOption>
  );
};

export default DeleteGroupAndUsersOption;
